import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router} from '@angular/router';
import {ScheduleService} from '../../services/schedule.service';
import {UnitSelectionService} from '../../services/unit-selection-service';
import {RatingService} from '../../services/rating.service';
import {ProductService} from '../../services/product-service';
import {ModelService} from '../../services/model-service';
import {RatingUnitService} from '../../services/rating-unit.service';
import {RatingUnit} from '../../model/rating-unit';
import {PersonLogin} from '../../person/person-login';
import {PersonLoginService} from '../../services/person-login-service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RatingsToolFormComponent} from '../ratings-tool-form/ratings-tool-form.component';

import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'app-ratings-tool',
    templateUrl: './ratings-tool.component.html',
    styleUrls: ['./ratings-tool.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatIcon, RatingsToolFormComponent]
})
export class RatingsToolComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly scheduleService = inject(ScheduleService);
  private readonly unitSelectionService = inject(UnitSelectionService);
  private readonly ratingService = inject(RatingService);
  private readonly productService = inject(ProductService);
  private readonly modelService = inject(ModelService);
  private readonly ratingUnitService = inject(RatingUnitService);
  private readonly userLoginService = inject(PersonLoginService);
  private readonly snackbar = inject(MatSnackBar);


  readonly errorMessage = signal<string>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);
  personLogin!: PersonLogin;
  unitToUpdate!: RatingUnit;
  updatedUnit!: RatingUnit;

  ngOnInit(): void {
    this.isBusy.set(true);
    this.personLogin = this.userLoginService.getCachedLogin()!;
    this.unitToUpdate = this.ratingUnitService.getQuickRateUnit();
    this.isBusy.set(false);
  }

  clearInputs(): void {
    this.ratingUnitService.clearQuickRateUnit();
    this.unitToUpdate = new RatingUnit();
    this.updatedUnit = undefined!;
  }

  ngOnDestroy(): void {
    this.ratingUnitService.setQuickRateUnit(this.updatedUnit);
  }

  canSave(): boolean {
    if (this.isBusy()) {
      return false;
    }
    return (this.updatedUnit?.response?.PrimaryCoilResponse?.TotalCapacity || 0) > 0 || (this.updatedUnit?.response?.ElectricHeatResponse?.LeavingDryBulbTemperature || 0) > 0;
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    if (error.error) {
      this.errorMessage.set(error.error);
    } else {
      this.errorMessage.set('An error has occurred.  Please contact Customer Service');
    }
  }

  addWorkingUnit(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.updatedUnit.personId = this.personLogin.person.personId;
    this.updatedUnit.airFilterCode = this.updatedUnit.request?.Filter || '';
    this.updatedUnit.orgUnitId = this.personLogin.person.primaryOrgUnitId;
    this.updatedUnit.id = 0;
    this.updatedUnit.requestId = 0;
    this.updatedUnit.responseId = 0;
    this.ratingUnitService.saveUnit(this.updatedUnit).subscribe({
      next: (unit) => {
        this.ratingUnitService.setQuickRateUnit(unit);
        this.snackbar.open('Unit Added!', 'Close', {duration: 10000});
      },
      complete: () => this.isBusy.set(false),
      error: (error) => this.handleError(error)
    });
  }

}
